import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";

/********* 退會年齡層占比 *********/
const QuitMemberAgeDistribution = React.forwardRef((props, ref) => {
    const chartDomRef = useRef(null);
    const {
        sourceData = {
            axis: {
                labels: ["18以下", "18-25", "26-35", "36-45", "46-55", "56-65", "66-75", "75歲以上"],
            },
            series: { data: [0, 3, 6, 7, 8, 1, 0, 0] },
        },
    } = props;
    const { axis = {}, series = {} } = sourceData;
    const axisLabels = axis?.labels ?? [];
    const seriesData = series?.data ?? [];
    const isLoading = seriesData.length === 0;
    const title = "退會年齡層占比";

    const option = {
        title: {
            text: title,
            left: 24,
            top: 20,
            textStyle: {
                fontSize: 20,
                fontWeight: 600,
                color: "#1F2937",
            },
        },

        grid: {
            left: 60,
            right: 40,
            top: 100,
            bottom: 50,
        },

        tooltip: {
            trigger: "axis",
            formatter: params => {
                const item = params[0];
                return `${item.name}<br/>${item.marker} ${item.value} 人`;
            },
            axisPointer: {
                type: "shadow",
            },
        },
        
        xAxis: {
            type: "category",
            data: axisLabels,
            axisTick: { show: false },
            axisLine: {
                lineStyle: {
                    color: "#374151",
                },
            },
            axisLabel: {
                fontSize: 14,
            },
        },

        yAxis: {
            type: "value",
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
                fontSize: 14,
            },
            splitLine: {
                lineStyle: {
                    type: "dashed",
                    color: "#E5E7EB",
                },
            },
        },

        series: [
            {
                type: "bar",
                data: seriesData,
                barWidth: 30,
                itemStyle: {
                    color: "rgb(148, 163, 184)",
                    borderRadius: [6, 6, 0, 0],
                },
            },
        ],
    };

    useEChart(chartDomRef, option);

    return (
        <Card style={{ width: "100%", height: "100%" }}>
            <Card.CardContent style={{ width: "100%", height: "100%" }}>
                {isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
            </Card.CardContent>
        </Card>
    );
});

export default QuitMemberAgeDistribution;
